module.exports = __webpack_public_path__ + "4ba4395c99b11e27d3b37d98d8a5c2c1.MP3";